import React, {
  useContext,
  useEffect,
  useState,
} from "react";
import { ThemeContext } from "styled-components/macro";
import { Outlet } from "react-router-dom";
import { Hidden, CssBaseline } from "@mui/material";
import GlobalStyle from "../../components/GlobalStyle";
import Navbar from "../../components/navbar/Navbar";
import dashboardItems from "../../components/sidebar/dashboardItems";
import Sidebar from "../../components/sidebar/Sidebar";
import Footer from "../../components/Footer";
import SessionTimeoutDialog from "../../components/session/SessionTimeoutDialog";
import useAppSelector from "../../hooks/useAppSelector";
import { connectSocket, disconnectSocket } from "../../redux/slices/socket";
import useAppDispatch from "../../hooks/useAppDispatch";
import { Root, Drawer, AppContent, MainContent } from "./styled";
import { drawerToggleCallback } from "./utils";

const Dashboard: React.FC = ({ children }) => {
  const dispatchStore = useAppDispatch();
  const { _user } = useAppSelector((state) => state.user);
  const [mobileOpen, setMobileOpen] = useState(false);
  const {
    sidebar: { width: drawerWidth },
  } = useContext(ThemeContext);
  const handleDrawerToggle = drawerToggleCallback(mobileOpen, setMobileOpen);

  const socketChannel = `user.${_user?.id}`;
  /* istanbul ignore next */
  useEffect(() => {
    if (_user) {
      dispatchStore(
        connectSocket({
          query: {
            socket_channel: socketChannel,
          },
        })
      );
    } else dispatchStore(disconnectSocket());
    return () => {
      dispatchStore(disconnectSocket());
    };
  }, [_user]);

  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      <SessionTimeoutDialog />
      <Drawer width={drawerWidth}>
        <Hidden lgUp implementation="js">
          <Sidebar
            PaperProps={{ style: { width: drawerWidth } }}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            items={dashboardItems}
          />
        </Hidden>
        <Hidden mdDown implementation="css">
          <Sidebar
            PaperProps={{ style: { width: drawerWidth } }}
            items={dashboardItems}
          />
        </Hidden>
      </Drawer>
      <AppContent>
        <Navbar onDrawerToggle={handleDrawerToggle} />
        <MainContent pl={1} pr={3} pb={1}>
          {children}
          <Outlet />
        </MainContent>
        <Footer />
      </AppContent>
    </Root>
  );
};

export default Dashboard;
